<template>
  <div class="content">
    <div :class="{bg: true, empty: list.length === 0}" ref="list">
      <interviewFilter ref="interviewFilter" @getData="getFilter" :showCreate="showCreate" />
      <div class="list">
        <div class="titles">
          <span class="theme">主题</span>
          <span class="remarktxt" v-show="!tagMark">备注</span>
          <span class="department">部门</span>
          <span class="publisher">发布者</span>
          <span class="reporter">记者</span>
          <span class="locate">地点</span>
          <span class="status">状态</span>
          <span class="time">开始/结束时间</span>
          <span class="upload">上传</span>
          <span class="handles">操作</span>
        </div>
        <empty :mTop="30" :msg="`暂无${$_syscfg.interview}数据`" v-if="list && list.length === 0" />
        <div class="items" v-for="(i, d) in list" :key="d">
          <div class="item">
            <span class="theme" @click="goDetail(i.id)">
              <p class="words" :title="i.title">
                {{i.title}}
              </p>
              <span class="msgIcon" v-if="i.remark && tagMark">
                <img src="@assets/img/interview/msg.svg" alt="msg">
                <p class="msgContent">
                  {{i.remark}}
                </p>
              </span>
              <img src="@assets/img/interview/new.svg" alt="new" v-if="i.is_new == 1">
              <img class="cameraG" src="@assets/img/interview/cameraG.png" v-if="i.has_expand" alt="camera">
              <span v-if="i.expand_icon && i.expand_icon.has_icon" class="backIcon">
                <img src="@assets/img/interview/back.png" alt="msg">
                <div class="backContent">
                  <p>{{i.expand_icon.msg}}</p>
                </div>
              </span>
              <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.has_change - 0 === 1">
            </span>
            <span class="remarktxt" v-show="!tagMark">{{i.remark || '无'}}</span>
            <span class="department">{{i.depart_name}}</span>
            <span class="publisher card" @click="showCard(i.uid, $event)">{{i.user_name}}</span>
            <span class="reporter">
              <!-- {{i.reporters.map(j => {return j.name}).join(',')}} -->
              <span class="card" v-for="(r, rd) in i.reporters" :key="rd" @click="showCard(r.id, $event)">
                {{r.name}}{{rd===i.reporters.length-1?'':','}}
              </span>
            </span>
            <span class="locate">{{i.address}}</span>
            <span :class="{status: true, done: i.status_name === '已完成'}">{{i.status_name}}</span>
            <span class="time">
              <span>{{i.start}}</span>
              <span>{{i.end}}</span>
            </span>
            <span class="upload">{{i.upload_content_num}}</span>
            <span class="handles">
              <span class="upBtn" @click="goClue(i)" v-if="(i.status == 2 || i.status == 3) && i.has_material_role">
                上传
              </span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import interviewFilter from '@components/interviewFilter'
import pages from '@components/pages'
import {apis} from '@common/config'
import common from '@common/common'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'allInterviews',
  components: {
    interviewFilter, pages, empty
  },
  data() {
    return {
      page: {
        pageSize: 10,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      list: [],
      searchOptions: {},
      filterOptions: {},
      showCreate: false,
      tagMark: false // 是否显示图标tag
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return
      
      const el = e.target

      this.$card(id, el)
    },
    goClue(i) {
      // 去创建线索页
      // const d = {
      //   id: i.id,
      //   title: i.title
      // }
      //
      // this.$router.push({
      //   name: 'creatClue',
      //   params: {
      //     interview: d
      //   }
      // })
      dc.setItv(i)

      common.jump('/creatClue', true)

      setTimeout(() => {
        dc.delItv()
      }, 0)
    },
    goDetail(i) {
      // 跳转详情页
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/interviewDetail?r=${i}`, true)
    },
    getList(keyWord) {
      // 获取列表
      const id = this.$route.params.id

      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        has_material: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.Itv_interviews, info)
      .then((data) => {
        this.list = data.list
        this.generateSearchs(data.params.top_search.option.list)
        this.generateFilters(data.params.list_search)
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
        this.showCreate = data.has_add_role

        this.$nextTick(() => {
          this.whetherShowTagMark()
        })
      })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.$refs.interviewFilter.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }
        })
      })

      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.$refs.interviewFilter.filters = filters
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getFilter(data) {
      // 接收过滤框数据
      this.filterOptions = data
      this.page.pageIndex = 1
      this.getList()
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    whetherShowTagMark() {
      // 计算宽度，是否显示标题上的标签
      const list = this.$refs.list
      if (!list || !list.getBoundingClientRect()) return
      const listWidth = list.getBoundingClientRect().width
      const limitWidth = 1100

      if (listWidth <= limitWidth) {
        this.tagMark = true
      } else {
        this.tagMark = false
      }
    },
    watchResize() {
      // 监听宽度变化
      window.addEventListener('resize', () => {
        this.whetherShowTagMark()
      })
    }
  },
  mounted() {
    this.getList('noKeyWord')
    // 默认渲染当天数据
    // this.$refs.interviewFilter.initDate()
    this.watchResize()
  }
}
</script>

<style lang="less" scoped src="@assets/css/interview/allInterviews.less"></style>
